@if (minimize()) {
    <nz-tag
        nz-tooltip
        nzMode="closeable"
        nzTooltipPlacement="bottom"
        (nzOnClose)="onImpersonationClose()"
        [nzTooltipTitle]="'Impersonating: ' + (user() | userName)"
    >
        Remove Impersonation
    </nz-tag>
} @else {
    <nz-alert
        nzShowIcon
        nzType="warning"
        [nzDescription]="impersonateTmpl"
        [nzMessage]="'Impersonating: ' + (user() | userName)"
    />

    <ng-template #impersonateTmpl>
        <p>You're using the dashboard on user's behalf. Proceed with caution.</p>
        <adspt-icon
            class="hide-banner a-pos-abs"
            (click)="minimize.set(true)"
            nz-tooltip
            nzTooltipTitle="Minimize this banner"
            nzTooltipPlacement="left"
            name="caret-up"
        />
    </ng-template>
}
